import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

/**
 * Minta server mengosongkan (mengarsipkan) daftar menu pegawai yang baru
 * dinonaktifkan. Best-effort: bila gagal, jadwal harian di server tetap merapikannya.
 * Lihat docs/PANDUAN_AKSES_PEGAWAI_NONAKTIF.md.
 */
export const arsipkanAksesPegawaiNonaktif = (guruIds: string[]) => {
    const fn = httpsCallable(functions, 'sinkronAksesNonaktif');
    guruIds.forEach(guruId => {
        fn({ guruId }).catch(e => console.warn('Arsip akses pegawai nonaktif gagal (akan dirapikan jadwal harian):', e?.message || e));
    });
};

/** Super admin: rapikan semua pegawai Nonaktif sekarang. */
export const rapikanAksesSemuaNonaktif = async (): Promise<{ diperiksa: number; dikosongkan: number }> => {
    const res = await httpsCallable(functions, 'sinkronAksesNonaktif')({});
    return res.data as { diperiksa: number; dikosongkan: number };
};
